import { ISearchDiscount } from 'interfaces/search.model';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector, useAppDispatch } from 'redux/hooks';
import { discountsSelectors } from 'redux/modules/Discounts';
import { fetchRecentSearch } from 'redux/modules/Discounts/discounts';

export const useRecentDiscount = (): [
  ISearchDiscount[] | undefined,
  string,
] => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const recentSearch = useAppSelector(discountsSelectors.getRecentSearch);

  const mappedRecentSearch = recentSearch?.map((item) => ({
    ...item,
    categoryTitle: 'recent',
  }));

  useEffect(() => {
    dispatch(fetchRecentSearch());
  }, []);

  return [mappedRecentSearch, t('search.recent')];
};
